import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/client/$accountId/_clientWrapper/settings/',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: `/client/$accountId/settings/general`,
      params: {
        accountId: params.accountId,
      },
      replace: true,
    });
  },
});
